import React, { useMemo } from 'react';

import { Button } from 'shadcn/components/ui/Button';
import { cn } from 'shadcn/lib/utils';

import { ReceiveFooterSummary } from './ReceiveFooterSummary';
import { getAllocationVarianceWarnings, summarizeEnteredCasesBySource } from './receiveFooterUtils';

/**
 * @typedef {{ id: number, code: string, displayName: string }} CompanySource
 * @typedef {{ id: string, companySourceId: number | null, numCases: number, expiration: string, supplierLot: string }} PalletLine
 * @typedef {{ id: string, lines: PalletLine[] }} Pallet
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {CompanySource[]} props.companySourceOptions
 * @param {boolean} [props.isThirdPartyAsn]
 * @param {boolean} [props.isSubmitting]
 * @param {() => void} props.onSubmit
 * @param {Pallet[]} props.pallets
 * @param {Array<{ companySource: CompanySource, numCases: number }>} [props.suggestedAllocations]
 */
function ReceiveFooter({
    className,
    companySourceOptions,
    isSubmitting = false,
    isThirdPartyAsn = false,
    onSubmit,
    pallets,
    suggestedAllocations = [],
}) {
    const { bySource, grandTotal } = useMemo(
        () => summarizeEnteredCasesBySource(pallets, companySourceOptions),
        [companySourceOptions, pallets],
    );

    const varianceWarnings = getAllocationVarianceWarnings(
        suggestedAllocations,
        { bySource, grandTotal },
        { isThirdPartyAsn },
    );

    return (
        <div className={cn('mt-4 flex shrink-0 items-stretch gap-3 border-t bg-background pt-4', className)}>
            <ReceiveFooterSummary
                bySource={bySource}
                grandTotal={grandTotal}
                isThirdPartyAsn={isThirdPartyAsn}
                varianceWarnings={varianceWarnings}
            />
            <Button
                className="shrink-0 self-stretch bg-[#4C884B] px-4 text-white hover:bg-[#4C884B]/90"
                disabled={isSubmitting}
                type="button"
                onClick={onSubmit}
            >
                Submit & Print Labels
            </Button>
        </div>
    );
}

export { ReceiveFooter };
